export default __webpack_public_path__ + "static/media/hm.15a28b2b.svg";